import { Fragment } from 'react';
import { TickIcon } from '@root/styles/icons';
import { useLabels } from '@features/Menu/useLabels';

import {
  ConnectingLine,
  CurrentStepIndicator,
  StepContainer,
  StepIcon,
  StepLabel,
  StepStage,
} from './DisplayCurrentStep.styles';
import { StepType } from '../../types';

const stepLabelKeyMap: Record<StepType, string> = {
  rooms: 'rooms',
  spa: 'spa',
  dining: 'tables',
};

export const DisplayCurrentStep = ({
  steps,
  currentStep,
}: {
  steps: StepType[];
  currentStep: string;
}): JSX.Element => {
  const labels = useLabels();

  function isStepComplete(step: StepType) {
    if (step === 'rooms' && currentStep !== 'rooms') return true;
    if (step.includes('spa') && currentStep === 'tables') return true;
    return false;
  }

  function isCurrentStep(step: StepType) {
    if (step === 'rooms' && currentStep === 'rooms') return true;
    if (step.includes('spa') && currentStep === 'spa') return true;
    if (step === 'dining' && currentStep === 'tables') return true;
    return false;
  }

  return (
    <StepContainer>
      {steps.map((step, index) => (
        <Fragment key={index}>
          {index === steps.length - 1 && <ConnectingLine />}
          <StepStage key={step}>
            <StepIcon>
              {isStepComplete(step) && <TickIcon />}
              {isCurrentStep(step) && <CurrentStepIndicator />}
            </StepIcon>
            <StepLabel>{labels?.[stepLabelKeyMap[step]] || step}</StepLabel>
          </StepStage>
          {index === 0 && <ConnectingLine />}
        </Fragment>
      ))}
    </StepContainer>
  );
};
